var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#icon-minus',
                        view: publicPath + 'sprite.svg#view-icon-minus',
                        viewBox: '0 0 40 40',
                        title: 'icons/fonctions/moins',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };